import React from 'react'
import { usePartner } from '../../helpers/BrandPageAPI';
import { Link, useParams } from 'react-router-dom';

const CollectionShow = () => {
    const { partnerData } = usePartner();
    const customerStore = useParams();
    const navColor = partnerData?.StoreColor || "#d4af37";
    const customerLink = customerStore?.UserCode;

    return (
        <div className='collection_shop'>
            <div className="container-xxl">
                <div className="collection-title">
                    <h2>Shop by Collection</h2>
                </div>
                <div className='collection_shop_grid'>
                    {Array.isArray(partnerData?.Collection) && partnerData.Collection.length > 0 &&
                        partnerData.Collection.map((Collection, index) => (
                            <div className='collection_gallary' key={index}>
                                <div className="collection_gallary_img">
                                    {/* <img
                                        src="https://www.tanishq.co.in/on/demandware.static/-/Library-Sites-TanishqSharedLibrary/default/dw770a9bca/homepage/tanishq-pillars/tw-nt-wedding-desktop.jpg"
                                        alt="category_img"
                                    /> */}
                                    <Link
                                        to={`/${customerLink}/category/${Collection.GatiCategoryId}`}
                                        style={{ color: navColor, textAlign: "center", paddingTop: "15px" }}
                                    >
                                        {Collection.DesgGroupName}
                                    </Link>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    )
}

export default CollectionShow